import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppBase } from '../app-base';
import { UserService } from './user.service';
import { CommonExpensesService } from '../common-expense/report/common-expenses/common-expenses.service';
import { StatusProcessService } from './status-process.service';
import { ModalLockComponent } from '../controls/modal-lock/modal-lock.component';

@Injectable()
export class CommonExpenseGuardService extends AppBase implements CanActivate {

  public guardIsRunning = false;
  public modalControl: ModalLockComponent;
  protected _guardURL: string;
  protected STATUS_PROCESS_RUNNING = 'STATUS_PROCESS_RUNNING';
  protected STATUS_PROCESS_FINISHED = 'STATUS_PROCESS_FINISHED';
  protected lastStatusProcess: string;

  constructor(private _router: Router,
              private _commonExpenseService: CommonExpensesService,
              private _statusProcessService: StatusProcessService,
              private _userService: UserService) {
    super();
    this.initStatusProcessTasks(this._statusProcessService);
  }

  openModal() {
    if (this.modalControl) {
      this.modalControl.openModal();
    }
  }

  closeModal() {
    if (this.modalControl) {
      this.modalControl.closeModal();
    }
  }

  setModalControl(modalLock: ModalLockComponent) {
    this.modalControl = modalLock;
  }

  getGuardURL() {
    return this._guardURL;
  }

  setGuardURL(url: string) {
    this._guardURL = url;
    return this;
  }

  getCommunityToken() {
    return `common_expense__closure__${this.getCurrentUser().community_id}`;
  }

  getCurrentWindowLocation() {
    return window.location.hash.substr(1);
  }

  isRoutingMatch() {
    return this.getGuardURL() === this.getCurrentWindowLocation();
  }

  lockCurrentModule() {
    if (!this.isRoutingMatch()) {
      this.closeModal();
      return;
    }
    this.openModal();
  }

  unlockCurrentModule() {
    this.closeModal();
  }

  checkCommonExpenseStatus() {
    this.checkStatusProcess(this.getCommunityToken(), () => {
      this.guardIsRunning = false;
      this.unlockCurrentModule();
    }, () => {
      this.guardIsRunning = false;
      this.unlockCurrentModule();
    }, (process) => {
      this.checkLastStatusProcess(process.status);
      if (process.status === this.STATUS_PROCESS_RUNNING && process.key === this.getCommunityToken()) {
        this.lockCurrentModule();
      } else {
        this.unlockCurrentModule();
      }
    });
  }

  checkStatus(url: string) {
    this.setGuardURL(url);

    // Running once
    if (!this.guardIsRunning) {
      this.guardIsRunning = true;
      this.checkCommonExpenseStatus();
    }
  }

  checkLastStatusProcess(status: string) {
    if (this.lastStatusProcess === this.STATUS_PROCESS_RUNNING && status === this.STATUS_PROCESS_FINISHED) {
      this._router.routeReuseStrategy.shouldReuseRoute = () => false;
      this._router.onSameUrlNavigation = 'reload';
      this._router.navigate([this.getGuardURL()]);
    }
    this.lastStatusProcess = status;
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    this.checkStatus(state.url);

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/common-expense-guard.service.ts